import { Card, Col, Divider, Row, Typography } from "antd";
import React, { useState } from "react";
import TurnoForm from "./TurnoForm";
import TurnoList from "./TurnoList";
import "./TurnoStyles.css";

const { Title } = Typography;

const TurnoManagement = () => {
    const [refreshKey, setRefreshKey] = useState(0);
    const [selectedTurno, setSelectedTurno] = useState(null);
    const isMobile = window.innerWidth < 768;

    // Esta función se ejecutará cuando se agregue un nuevo turno
    const handleTurnoAdded = () => {
        // Incrementar el key para forzar la actualización de la lista de turnos
        setRefreshKey((prevKey) => prevKey + 1);
    };

    // Esta función se ejecutará cuando se edite un turno
    const handleTurnoEdited = (turno) => {
        setSelectedTurno(turno);
    };

    // Esta función se ejecutará cuando se actualice un turno
    const handleTurnoUpdated = () => {
        // Limpiar el turno seleccionado e incrementar el key para actualizar la lista
        setSelectedTurno(null);
        setRefreshKey((prevKey) => prevKey + 1);
    };

    return (
        <div className="turno-management-container">
            <Title level={2}>{isMobile ? "Turnos" : "Gestión de Turnos"}</Title>
            <Divider />

            <Row gutter={[24, 24]}>
                <Col xs={24} lg={12}>
                    <Card>
                        <TurnoForm
                            onTurnoAdded={handleTurnoAdded}
                            onTurnoUpdated={handleTurnoUpdated}
                            turnoToEdit={selectedTurno}
                        />
                    </Card>
                </Col>

                <Col xs={24} lg={12}>
                    <TurnoList
                        refreshTrigger={refreshKey}
                        onEditTurno={handleTurnoEdited}
                    />
                </Col>
            </Row>
        </div>
    );
};

export default TurnoManagement; 